/**
 * Caminho SVG de um gráfico de área suave (Catmull-Rom convertido em Bézier).
 *
 * `points` vai de 0 (base) a 1 (topo). Toda série com o mesmo número de pontos
 * gera um caminho com os mesmos comandos — é isso que deixa o framer-motion
 * transformar uma curva na outra animando o atributo `d`.
 */
export function areaPath(points: number[], width: number, height: number) {
  const step = width / (points.length - 1);
  const xy = points.map((p, i) => [i * step, height - p * height] as const);

  let d = `M ${xy[0][0]} ${xy[0][1]}`;
  for (let i = 0; i < xy.length - 1; i++) {
    const p0 = xy[Math.max(i - 1, 0)];
    const p1 = xy[i];
    const p2 = xy[i + 1];
    const p3 = xy[Math.min(i + 2, xy.length - 1)];
    const c1 = [p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6];
    const c2 = [p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6];
    d += ` C ${c1[0]} ${c1[1]} ${c2[0]} ${c2[1]} ${p2[0]} ${p2[1]}`;
  }
  return `${d} L ${width} ${height} L 0 ${height} Z`;
}
